import { render, staticRenderFns } from "./option-card.vue?vue&type=template&id=4583e6d7&scoped=true&"
import script from "./option-card.vue?vue&type=script&lang=js&"
export * from "./option-card.vue?vue&type=script&lang=js&"
import style0 from "./option-card.vue?vue&type=style&index=0&id=4583e6d7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4583e6d7",
  null
  
)

export default component.exports